import React from 'react';
import { X, FileText } from 'lucide-react';

const TemplateSelectionModal = ({ 
  isOpen, 
  onClose, 
  templates, 
  onSelectTemplate, 
  isLoading 
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-2xl">
        <div className="flex-between mb-6">
          <h2 className="text-xl font-bold text-gray-900">
            계약서 템플릿 선택
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="space-y-4">
          <p className="text-gray-600">
            발송할 계약서 템플릿을 선택해주세요.
          </p>

          {isLoading ? (
            <div className="flex justify-center py-8">
              <div className="loading">템플릿을 불러오는 중...</div>
            </div>
          ) : (
            <div className="grid gap-3">
              {templates?.map((template) => (
                <button
                  key={template.template_id}
                  onClick={() => onSelectTemplate(template)}
                  className="flex items-center p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors text-left w-full"
                >
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <FileText size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">
                        {template.template_name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        필드 수: {template.field_ids?.length || 0}개
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}

          {!isLoading && (!templates || templates.length === 0) && (
            <div className="text-center py-8 text-gray-500">
              사용 가능한 템플릿이 없습니다.
            </div>
          )}
        </div>

        <div className="flex justify-end mt-6 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="btn btn-outline"
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateSelectionModal;
